import { z } from 'zod';
import { defineEndpoint } from '../define';
import { UserRefSchema } from '../user-ref';

const params = z.object({ pollId: z.string().uuid() });
const response = z.object({ data: z.array(UserRefSchema) });

export const getPollViewers = defineEndpoint({
  method: 'GET',
  path: '/v1/polls/:pollId/viewers',
  params,
  query: z.object({}),
  body: z.undefined(),
  response,
});

export const getPollViewerCandidates = defineEndpoint({
  method: 'GET',
  path: '/v1/polls/:pollId/viewer-candidates',
  params,
  query: z.object({}),
  body: z.undefined(),
  response,
});

export const replacePollViewers = defineEndpoint({
  method: 'PUT',
  path: '/v1/polls/:pollId/viewers',
  params,
  query: z.object({}),
  body: z.object({ userIds: z.array(z.string().uuid()).max(500) }),
  response,
});
